import { GlowBackground } from '../components/ui/GlowBackground';
import { Navbar } from '../components/landing/Navbar';
import { HeroSection } from '../components/landing/HeroSection';
import { TrustedBy } from '../components/landing/TrustedBy';
import { FeaturesTabs } from '../components/landing/FeaturesTabs';
import { BenefitsGrid } from '../components/landing/BenefitsGrid';
import { TestimonialsCarousel } from '../components/landing/TestimonialsCarousel';
import { AIPresentationSection } from '../components/landing/AIPresentationSection';
import PricingSection from '../components/landing/PricingSection';
import { DiscordCommunitySection } from '../components/landing/DiscordCommunitySection';
import { FAQSection } from '../components/landing/FAQSection';
import { Footer } from '../components/landing/Footer';

export default function LandingPage() {
  return (
    <div className="min-h-screen text-[rgb(var(--fg))] relative overflow-hidden">
      <GlowBackground />
      <div className="relative z-10">
        <Navbar />
        <main>
          <HeroSection />
          <TrustedBy />
          <AIPresentationSection />
          <FeaturesTabs />
          <BenefitsGrid />
          <TestimonialsCarousel />
          <PricingSection />
          <DiscordCommunitySection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </div>
  );
}

